
import { Inertia } from "@inertiajs/inertia";
import { computed, defineComponent } from "vue";
import ButtonGroup from "../Buttons/ButtonGroup.vue";
import Card from "../General/Card.vue";

export default defineComponent({
  setup() {
    const options = [
      {
        id: 1,
        title: "Siste 7 dager",
        url: route("reports.out-of-production.week"),
      },
      {
        id: 2,
        title: "Siste 14 dager",
        url: route("reports.out-of-production.weeks"),
      },
      {
        id: 3,
        title: "Siste 30 dager",
        url: route("reports.out-of-production.month"),
      },
    ];

    const selected = computed(() => {
      const result = options.filter(
        (item) => item.url === route(route().current() ?? "")
      );

      if (result.length > 0) {
        return result[0].id;
      }

      return null;
    });

    const navigate = (item: any) => {
      Inertia.get(item.url);
    };

    return {
      options,
      selected,
      navigate,
    };
  },
  components: { ButtonGroup, Card },
});
